/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../../app/@shared/tracking/user-timing-tracking.component';
import * as import2 from '../../../../app/@shared/tracking/tracking.service';
const styles_UserTimingTrackingComponent:any[] = ([] as any[]);
export const RenderType_UserTimingTrackingComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_UserTimingTrackingComponent,
  data: {}
}
);
export function View_UserTimingTrackingComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_UserTimingTrackingComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-user-timing-tracking',([] as any[]),(null as any),(null as any),(null as any),View_UserTimingTrackingComponent_0,RenderType_UserTimingTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import1.UserTimingTrackingComponent,[import2.Tracking],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const UserTimingTrackingComponentNgFactory:import0.ComponentFactory<import1.UserTimingTrackingComponent> = import0.ɵccf('fl-user-timing-tracking',import1.UserTimingTrackingComponent,View_UserTimingTrackingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy91c2VyLXRpbWluZy10cmFja2luZy5jb21wb25lbnQudHMuVXNlclRpbWluZ1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3VzZXItdGltaW5nLXRyYWNraW5nLmNvbXBvbmVudC50cy5Vc2VyVGltaW5nVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC11c2VyLXRpbWluZy10cmFja2luZz48L2ZsLXVzZXItdGltaW5nLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7eUJDQUE7Ozs7SUNBQTtnQkFBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/@shared/tracking/user-timing-tracking.component.ngfactory.ts